import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import 'hammerjs';
import {
  EnvironmentConfiguration, environments
} from './app/environment/services/environment.configuration';
import { API_ENDPOINTS } from './environments/api-endpoints';

const environment = new EnvironmentConfiguration(environments);

if (environment.production) {
  enableProdMode();
}

if (environment.hostname === API_ENDPOINTS.HOSTNAME.PROD) {
  document.write('<script src="//nexus.ensighten.com/toyotanational/t-rti-prod/Bootstrap.js"></script>');
} else {
  document.write('<script src="//nexus.ensighten.com/toyotanational/t-rti-stage/Bootstrap.js"></script>')
}

// For App Dynamic
if (environment.PERFORM_APP_DYNAMICS) {
  const appDynamicScript = `
      window['adrum-start-time'] = new Date().getTime();
      (function(config){
        config.appKey = '` + environment.APP_DYNAMIC_KEY + `';
        config.adrumExtUrlHttp = 'http://cdn.appdynamics.com';
        config.adrumExtUrlHttps = 'https://cdn.appdynamics.com';
        config.beaconUrlHttp = 'http://col.eum-appdynamics.com';
        config.beaconUrlHttps = 'https://col.eum-appdynamics.com';
        config.xd = {enable : false};
      })(window['adrum-config'] || (window['adrum-config'] = {}));
      if ('https:' === document.location.protocol) {
				document.write(unescape('%3Cscript')
			+ " src='https://cdn.appdynamics.com/adrum/adrum-4.5.4.1467.js' "
			+ " type='text/javascript' charset='UTF-8'"
			+ unescape('%3E%3C/script%3E'));
			} else {
				document.write(unescape('%3Cscript')
			+ " src='http://cdn.appdynamics.com/adrum/adrum-4.5.4.1467.js' "
			+ " type='text/javascript' charset='UTF-8'"
			+ unescape('%3E%3C/script%3E'));
			}`;

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.innerHTML = appDynamicScript;

  // it's important to append the app dynamics script to the header.
  document.getElementsByTagName('head')[0].appendChild(script);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

